import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ThanhLy } from "./ThanhLy";

export const BtnThanhLy = ({ hopdong, TaiSanID }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Thanh lý"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-thanh-ly-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ThanhLy
          show={show}
          onHide={handleClose}
          hopdongId={hopdong.ChoVayID}
          taiSanId={TaiSanID}
          choVayId={hopdong.ChoVayID}
        />
      )}
    </>
  );
};
